// extracted by mini-css-extract-plugin
export var actionText = "_jr-4";
export var container = "_jr-0";
export var leftSection = "_jr-1";
export var rightSection = "_jr-2";
export var settingsButton = "_jr-6";
export var settingsIcon = "_jr-7";
export var shortcut = "_jr-5";
export var shortcutGroup = "_jr-3";